export default (
	source,
	default_value = '',
	multi_select = false,
	format = 'string',
	all_value = '*',
	empty_value = '',
) => ({
	selected_value: default_value,
	selected_values: [],
	options: [],
	ready: false,
	source,
	init() {
		try {
			const options_text = this.$refs?.options?.textContent;
			if ( options_text ) { this.options = JSON.parse(options_text); }
		} catch(error) {
			console.error(`Can't parse options data:`, error);
		}
		this.$nextTick( () => this.setWidth() );
		if ( multi_select ) {
			if ( default_value ) { this.selected_values.push( default_value ); }
			this.setupMultiWatches();
		} else {
			this.setupSingleWatches();
		}
		this.$nextTick( () => this.setupFromUrl() );
	},
	setupFromUrl() {
		const value = new URLSearchParams(location.search).get(source);
		if ( value ) {
			if ( multi_select ) {
				this.selected_values = JSON.parse(value);
				this.$dispatch('filter', { 'key': source, value: this.selected_values });
			} else {
				this.selected_value = value;
				this.$dispatch('filter', { 'key': source, value });
			}
		}
		this.ready = true;
	},
	clearFilters() {
		this.selected_value = default_value;
		this.selected_values = [];
	},
	markUnavailableOptions() {
		// Only operate on data we care about
		if ( this.$event?.detail?.key !== source ) { return; }

		let available_options = this.$event?.detail?.options;
		if ( format === 'int' ) {
			available_options = available_options.map( _ => parseInt(_, 10) );
		}
		for ( let i = 0; i < this.options.length; i++ ) {
			this.options[i]['unavailable'] = !available_options.includes(this.options[i].key);
		}
	},
	setupSingleWatches() {
		this.$watch(
			'selected_value',
			(value) => {
				if ( !this.ready ) { return; }

				let url = new URL(window.location.href);

				if ( value === all_value ) {
					this.$dispatch('filter', { 'key': source, value: empty_value });
					url.searchParams.delete(source);
				} else {
					this.$dispatch('filter', { 'key': source, value });
					url.searchParams.set(source, value);
				}
				history.pushState(null, document.title, url.toString());
			}
		);
	},
	setupMultiWatches() {
		this.$watch(
			'selected_values',
			(value) => {
				if ( !this.ready ) { return; }

				let url = new URL(window.location.href);
				if ( (Object.keys(value)).length > 0 ) {
					url.searchParams.set(source, JSON.stringify(value));
				} else {
					url.searchParams.delete(source);
				}

				this.$dispatch('filter', { 'key': source, value });
				history.pushState(null, document.title, url.toString());
			}
		);
	},
	setWidth() {
		const $group = this.$root.querySelector('.c-filter-control__option-group');
		// Bail if no group
		if ( !$group ) {
			return;
		}
		$group.style.opacity = 0;
		$group.style.display = 'block';
		const $label = this.$root.querySelector('.c-filter-control__label');
		const width = Math.max($group.offsetWidth, $label.offsetWidth);
		this.$root.style.setProperty('--control-width', width + 'px');
		$group.style.display = 'none';
		$group.style.opacity = 1;
	}
});
